// extracted by mini-css-extract-plugin
export default {"small":"Copyright_small__vgFub"};